
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/rezervovat-dovolenku",
      function () {
        return require("private-next-pages/[region]/[resort]/rezervovat-dovolenku.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/rezervovat-dovolenku"])
      });
    }
  